<template>
  <span class="ic_myChallenge" :style="style">
  <!--  is-visible-->
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 153.1 40">
    <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
<!--    <defs>-->
<!--      <style>-->
<!--        .st0 {-->
<!--          fill: #151515;-->
<!--        }-->
<!--      </style>-->
<!--    </defs>-->
    <g id="Layer_1">
      <g id="Layer_2">
        <path id="Path" class="st0" d="M3.3,15.9L0,31.1h6.1l2.6-11.9c.2-1,.5-1.8,1-2.6.4-.7.9-1.3,1.5-1.8.6-.4,1.1-.6,1.7-.6s1.3.3,1.6.9c.3.6.3,1.4.1,2.4l-2.9,13.6h6.1l2.5-11.8c.2-1,.5-1.8,1-2.6.4-.8.9-1.4,1.5-1.8s1.1-.6,1.7-.6,1.3.3,1.6.9c.3.6.3,1.4,0,2.5l-1.9,8.9c-.4,1.7-.2,2.9.3,3.7.6.8,1.5,1.2,2.9,1.2s2.2-.2,3.3-.7c1-.5,1.8-1,2.4-1.7l.3-1.5c-.3.2-.6.4-1,.5s-.7.2-1,.2c-.5,0-.8-.2-1-.5s-.2-.8,0-1.5l1.8-8.2c.5-2.2.3-3.9-.5-5-.8-1.2-2.2-1.8-4.1-1.8s-2,.2-2.9.7-1.7,1.1-2.4,1.9c-.7.8-1.2,1.9-1.6,3v-.4c.1-1,0-2-.2-2.8-.3-.8-.8-1.4-1.6-1.9s-1.8-.7-3-.7-2.9.4-4.1,1.3-2.1,2.2-2.8,4l1.1-5.2-8.7,1-.3,1.4,1.3.3c.5.1.8.3.9.6,0,.2,0,.6,0,1.2v.2Z"/>
        <path id="Path1" class="st0" d="M43.2,11.4l-8,1-.3,1.4,1.1.2c.5.1.9.3,1.1.5.2.2.3.6.3,1.1l1.6,17.6c-.6.5-1.2,1-1.9,1.6s-1.5,1.1-2.3,1.7c-.8.6-1.6,1.1-2.4,1.6-.8.5-1.5,1-2.2,1.4v.4h6.1c.8-1,1.6-2,2.3-2.9s1.5-1.9,2.3-2.8c.5-.5.9-1.1,1.4-1.6s.9-1.1,1.4-1.6.9-1.1,1.3-1.6c1.9-2.4,3.5-4.5,4.7-6.4,1.3-1.9,2.2-3.6,2.8-5.1.6-1.4.9-2.6.9-3.6s-.3-1.7-.9-2.3-1.4-.9-2.3-.9-1.6.3-2.2.9-.9,1.3-.9,2.1.3,1.5.9,2.1c.6.6,1.3.9,2.1.9s1.5-.3,2.1-.7c.6-.5.8-1.1.8-1.9h-1.8c0,1.2-.4,2.6-1,4s-1.4,2.9-2.5,4.5c-1,1.6-2.3,3.3-3.7,5.1l-.9-16.7h.1Z"/>
      </g>
    </g>
    <g id="Layer_21" data-name="Layer_2">
      <g>
        <path class="st0" d="M77.6,17.2c-.5-.2-1-.5-1.5-.8-.6-.3-1.1-.7-1.7-1.1-.6-.4-1.1-.8-1.6-1.3-.5-.4-.9-.9-1.2-1.3-.4.5-.8,1-1.3,1.5-.5.5-1,1-1.6,1.5-.6.5-1.1,1-1.7,1.4-.6.4-1.1.8-1.6,1.2l-2.6-2.6c.9-.6,1.7-1.2,2.5-1.8.8-.6,1.5-1.3,2.1-1.9.6-.7,1.1-1.4,1.4-2.1.4-.7.6-1.5.6-2.2h-5.6v-3.4h5.6V0h4.1v4.2h5.4v3.4h-5.4c0,.8.3,1.6.7,2.2.4.7.9,1.3,1.4,1.9.6.6,1.2,1.1,1.9,1.5.7.5,1.4.9,2,1.2l-2.1,2.7ZM73.2,34.1c-2.4,0-3.6-1.2-3.6-3.6v-5.4h16.9v-2h-16.9v-3.5h20.2c.6,0,.9.3.9.9v8h-16.9v1.3c0,.5.2.7.7.7h16.9v3.5h-18.2ZM90.9,17.9h-4v-6.6h-2.5v6.6h-4V1.6h4v6.1h2.5V1.4h4v16.5Z"/>
        <path class="st0" d="M111.8,13h-10.9v3c0,.5.2.7.7.7h3.4c.4,0,.8,0,1.1,0s.7,0,1,0c1.4,0,2.7-.2,3.9-.3,1.2-.1,2.5-.3,3.7-.5l.2,3.1c-.9.3-2.1.5-3.4.8-1.4.2-2.9.4-4.5.4-2.2,0-4.4.1-6.6.1s-3.6-1.2-3.6-3.6v-7.1h10.9v-3.5h-10.9v-3.5h14.2c.6,0,.9.3.9.9v9.6ZM122.4,33.4h-18.2c-2.4,0-3.6-1.2-3.6-3.6v-6.3h4.2v5.5c0,.5.2.7.7.7h17v3.6ZM121.6,24.9h-4.2V1.4h4.2v23.4Z"/>
        <path class="st0" d="M144.3,26.2c-.6-.4-1.2-.8-1.9-1.4-.7-.6-1.5-1.3-2.2-2-.7-.7-1.4-1.5-2.1-2.2-.7-.8-1.2-1.5-1.6-2.1-.4.7-.9,1.4-1.5,2.2-.6.8-1.3,1.6-2,2.3-.7.8-1.5,1.5-2.3,2.1-.8.7-1.5,1.2-2.1,1.6l-2.6-2.7c1-.7,2.1-1.5,3.1-2.4,1-.9,1.9-1.9,2.7-2.9.8-1,1.4-2.1,1.9-3.2.5-1.1.7-2.2.7-3.4v-5.4h-6.6v-3.6h17.4v3.6h-6.6v5.4c0,1.2.3,2.3.8,3.4.5,1.1,1.2,2.1,2,3.1.8,1,1.7,1.9,2.6,2.7.9.8,1.8,1.5,2.5,2l-2.1,2.8ZM153.1,33.4h-4.2V1.4h4.2v32Z"/>
      </g>
    </g>
  </svg>
  </span>
</template>
<script>

export default {
  name: 'SSLMyChallengeSvg',
  props:{
    style:{
      type:String,
      default:'margin-top: 5px;'
    }
  }
}
</script>
